var _ellipse, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeamManagerIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 78,
    viewBox: "0 0 81 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.5,
    cy: 38.7525,
    rx: 39.8947,
    ry: 38.6622,
    fill: "#E6F6F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 46.6058C43.9427 46.6058 46.7336 43.9012 46.7336 40.5648C46.7336 37.2285 43.9427 34.5239 40.5 34.5239C37.0573 34.5239 34.2664 37.2285 34.2664 40.5648C34.2664 43.9012 37.0573 46.6058 40.5 46.6058Z",
    stroke: "#00A0B1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.097 36.9403C52.5491 36.9379 53.9816 37.2644 55.2803 37.8937C56.579 38.523 57.708 39.4377 58.5773 40.5648",
    stroke: "#00A0B1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4227 40.5648C23.292 39.4377 24.421 38.523 25.7197 37.8937C27.0185 37.2644 28.451 36.9379 29.903 36.9403",
    stroke: "#00A0B1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5235 52.0431C32.3444 50.4136 33.6212 49.0404 35.2082 48.0799C36.7952 47.1193 38.6287 46.61 40.4998 46.61C42.3709 46.61 44.2044 47.1193 45.7914 48.0799C47.3784 49.0404 48.6551 50.4136 49.4761 52.0431",
    stroke: "#00A0B1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9032 36.9403C28.9567 36.9412 28.0294 36.6811 27.2298 36.1903C26.4302 35.6995 25.7912 34.9983 25.3876 34.1687C24.9839 33.339 24.8322 32.4151 24.9502 31.505C25.0681 30.5949 25.451 29.7362 26.0539 29.0291C26.6568 28.322 27.4549 27.7958 28.3549 27.5119C29.255 27.2281 30.2198 27.1983 31.1366 27.4261C32.0535 27.6539 32.8845 28.1299 33.5326 28.7984C34.1806 29.4669 34.619 30.3004 34.7965 31.2013",
    stroke: "#00A0B1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2039 31.2013C46.3814 30.3004 46.8198 29.4669 47.4679 28.7984C48.116 28.1299 48.947 27.6539 49.8638 27.4261C50.7807 27.1983 51.7455 27.2281 52.6455 27.5119C53.5456 27.7958 54.3437 28.322 54.9466 29.0291C55.5495 29.7362 55.9323 30.5949 56.0503 31.505C56.1683 32.4151 56.0166 33.339 55.6129 34.1687C55.2092 34.9983 54.5702 35.6995 53.7706 36.1903C52.971 36.6811 52.0438 36.9412 51.0973 36.9403",
    stroke: "#00A0B1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamManagerIcon);
export default __webpack_public_path__ + "static/media/team-manager-icon.530b8663baf507d3abb5c4e11e806847.svg";
export { ForwardRef as ReactComponent };